export default {
  /* -------------------------------------------------------------------------- */
  /*                             Category List State                            */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  CategoryRecords: [],
  total: 0,
  FilteredCount: 0,
  /* -------------------------------------------------------------------------- */
  /*                            Create Category State                           */
  /* -------------------------------------------------------------------------- */
  createLoading: false,
  /* -------------------------------------------------------------------------- */
  /*                             Edit Category State                            */
  /* -------------------------------------------------------------------------- */
  editLoading: false,

  /* -------------------------------------------------------------------------- */
  /*                             Sub Category State                             */
  /* -------------------------------------------------------------------------- */
  subCategoryRecords: [],
  subtotal: 0,
  subFilteredCount: 0,
}
